// src/App.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { dummyProfiles, dummyRequestsToMe, dummyMyRequests } from './dummyProfiles';
import CardStack from './CardStack';
import Tabs from './Tabs';
import RequestItem from './RequestItem';
import DilConnects from './DilConnects';

function DilSwipe() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
        dispatch(logout());
        navigate("/");
  };

  const [activeTab, setActiveTab] = useState('discover'); 

    const tabs = [
    { id: "discover", label: "Discover", emoji: "🔍" },
    { id: "requests-to-me", label: "Requests to Me", emoji: "📥" },
    { id: "my-requests", label: "My Requests", emoji: "📤" },
    { id: "dil-connects", label: "Dil Connects", emoji: "❤️" },
    ];


  return (
    <div className="min-h-screen bg-red-800 flex flex-col">
      <header className="bg-red-800 border-b sticky top-0 z-10">
        <div className="flex flex-col px-1 py-1 font-bold text-xl text-pink-300">
          <h1 className='text-left'>💖 DilSwipe</h1>
          <p className='text-xs lg:text-sm text-left text-white'>Dil se swipe, dil se connect</p>
        </div>
      </header>

      <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />

      <main className="flex-1 flex flex-col w-full px-3 pb-6">
        {activeTab === 'discover' && (
          <div className="flex-1 flex items-center justify-center relative mt-4">
            <CardStack profiles={dummyProfiles} />
          </div>
        )}

        {activeTab === 'requests-to-me' && (
          <div className="space-y-4 mt-6">
            {dummyRequestsToMe.length === 0 ? (
              <p className="text-center text-gray-500 mt-10">No new requests yet</p>
            ) : (
              dummyRequestsToMe.map(req => (
                <RequestItem key={req.id} {...req} type="incoming" />
              ))
            )}
          </div>
        )}

        {activeTab === 'my-requests' && (
          <div className="space-y-4 mt-6">
            {dummyMyRequests.length === 0 ? (
              <p className="text-center text-gray-500 mt-10">You haven't sent any requests yet</p>
            ) : (
              dummyMyRequests.map(req => (
                <RequestItem key={req.id} {...req} type="outgoing" />
              ))
            )}
          </div>
        )}

        {activeTab === 'dil-connects' && (
          <DilConnects />
        )}
      </main>

      <footer className="bg-red-800 border-t border-red-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-white">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-white">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-white">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-white">Contact</Link>
            </div>
        </div>
      </footer>
    </div>
  );
}

export default DilSwipe;